const accordionHeader = document.querySelectorAll('.card--expandable .card-header');
const accordionBody = document.querySelectorAll('.collapse.show');

for (const body of accordionBody) {
  body.previousElementSibling.classList.add('is-active');
}

for (const accordion of accordionHeader) {
  accordion.addEventListener('click', event => {
    event.preventDefault();
    accordion.classList.toggle('is-active');
    accordion.nextElementSibling.classList.toggle('collapse');
    accordion.nextElementSibling.classList.toggle('show');
  });
}
